import { Injectable } from '@angular/core';
import { Http, Headers, RequestOptions } from '@angular/http';
import { Events } from 'ionic-angular';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/toPromise';

import { AuthServiceProvider } from '../auth-service/auth-service';

/*
  Generated class for the CarteraServiceProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class CarteraServiceProvider {

  datoconcepto: any;
  concepto: any;
  serverServicios = "";
  headers = new Headers();
  headersPost:any;

  constructor(public http: Http, public autorizacionService: AuthServiceProvider, public events: Events) {

    //this.serverServicios = "http://localhost:3000";
    this.serverServicios = "http://165.227.106.28:3000";
    this.headers.append('Authorization', this.autorizacionService.token);

    this.headersPost = new Headers({ 'Content-Type': 'application/json' });
    this.headersPost.append('Authorization', this.autorizacionService.token);
  }

  getReporte(idempresa,identidad)
  {
    return new Promise(resolve => {
      this.http.get(this.serverServicios + '/pospdf/pdf/'+idempresa+'/'+identidad, {headers: this.headers}).map(res => res.json()).subscribe(data => {
      resolve(data);
      }, err => {
        this.events.publish('user:validartoken', err._body);
      });
    }); 
    
  }
  getReporteConsolidado(idempresa,desde,hasta)
  {
    return new Promise(resolve => {
      this.http.get(this.serverServicios + '/pospdf/consolidado/'+idempresa+'/'+desde+'/'+hasta, {headers: this.headers}).map(res => res.json()).subscribe(data => {
      resolve(data);
      }, err => {
        this.events.publish('user:validartoken', err._body);
      });
    }); 
  }
  getReporteConsolidadoMes(idempresa,desde,hasta)
  {
    return new Promise(resolve => {
      this.http.get(this.serverServicios + '/pospdf/consolidadomes/'+idempresa+'/'+desde+'/'+hasta, {headers: this.headers}).map(res => res.json()).subscribe(data => {
        resolve(data);
      }, err => {
        this.events.publish('user:validartoken', err._body);
      });
    }); 
  }

  getConcepto()
  {
  	return new Promise(resolve => {
    this.http.get(this.serverServicios + '/posconcepto/1', {headers: this.headers}).map(res => res.json()).subscribe(data => {
      resolve(data);
    }, err => {
      this.events.publish('user:validartoken', err._body);
    });
   });

  }
  getCartera()
  {
    //let headers = new Headers();
    //headers = headers.append('Authorization', this.autorizacionService.token);

    return new Promise(resolve => {
      this.http.get(this.serverServicios + '/posdepartamento/1/0', {headers: this.headers}).map(res => res.json())
        .subscribe(data => {
          resolve(data);
        }, err => {
          this.events.publish('user:validartoken', err._body);
        });
    });    

  }
  getMedida()
  {
    return new Promise(resolve => {
    this.http.get(this.serverServicios + '/posmedida/1/0', {headers: this.headers}).map(res => res.json()).subscribe(data => {
      resolve(data);
    }, err => {
      this.events.publish('user:validartoken', err._body);
    });
   });
  }
  getDepartamento()
  {
    //let headers = new HttpHeaders();
    //headers = headers.set('Authorization', this.autorizacionService.token);
    
    return new Promise(resolve => {
    this.http.get(this.serverServicios + '/posdepartamento/1/0', {headers: this.headers}).map(res => res.json()).subscribe(data => {
      resolve(data);
    }, err => {
      this.events.publish('user:validartoken', err._body);
    });
    }); 
  }

  getGCartera(idempresax, idgcartera)
  {
    //let headers = new HttpHeaders();
    //headers = headers.set('Authorization', this.autorizacionService.token);
    
    return new Promise(resolve => {
    this.http.get(this.serverServicios + '/poscartera/'+ idempresax +'/'+idgcartera , {headers: this.headers}).map(res => res.json()).subscribe(data => {
      resolve(data);
    }, err => {
      this.events.publish('user:validartoken', err._body);
    });
    }); 
  }

  postMedida(data)
  {
    return new Promise((resolve, reject) => {
    this.http.post( this.serverServicios + '/posmedida/', JSON.stringify(data),  { headers: this.headersPost })
      .subscribe(res => {
        resolve(res);
      }, (err) => {
        this.events.publish('user:validartoken', err._body);
        reject(err);
      });
    });
  }

  postDepartamento(data)
  {
    return new Promise((resolve, reject) => {
    this.http.post( this.serverServicios + '/posdepartamento/', JSON.stringify(data),  { headers: this.headersPost })
      .subscribe(res => {
        resolve(res);
      }, (err) => {
        this.events.publish('user:validartoken', err._body);
        reject(err);
      });
    });
  }

  addCartera(data)
  {
    return new Promise((resolve, reject) => {
      this.http.post( this.serverServicios + '/poscartera/', JSON.stringify(data),  { headers: this.headersPost })
        .subscribe(res => {
          resolve(res);
        }, (err) => {
          this.events.publish('user:validartoken', err._body);
          reject(err);
        });
    });
  }

}



// WEBPACK FOOTER //
// ./src/providers/cartera-service/cartera-service.ts